import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=a367ac76&scoped=true"
import script from "./tabs.vue?vue&type=script&lang=ts"
export * from "./tabs.vue?vue&type=script&lang=ts"
import style0 from "./tabs.vue?vue&type=style&index=0&id=a367ac76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a367ac76",
  null
  
)

export default component.exports